import React, { useContext } from 'react';
import { FuelButton, FuelTypography } from '@frete.com/fuel-react';
import { FuelFlex } from '@frete.com/fuel-station-react';
import AppContext from '@context';
import { JourneysStateInterface } from '@context/reducers/journeys/journeys.type';
import { SectionActionPropsInterface } from './SectionActionTypes';
import * as Styled from './SectionActionStyles';

function SectionAction({
  title,
  description,
  action,
  innerRef,
}: SectionActionPropsInterface) {
  const {
    state: { journeys, ui },
  } = useContext(AppContext);
  const { data: journeySelection, isFetching } =
    journeys.selection as JourneysStateInterface['selection'];
  const journey = journeySelection?.journey;
  const hasDispute = !!(action.textDispute && action.onDispute);
  const hasConfirmed = action.onClick && action.text;

  if (journey?.status.slug === 'done') {
    return null;
  }

  function handleActionDispute() {
    if (hasDispute) {
      return (
        <FuelButton
          data-testid="sectionAction-dispute"
          onClick={action.onDispute}
          size="large"
          variant="tertiary"
        >
          {action.textDispute}
        </FuelButton>
      );
    }

    return null;
  }

  return (
    <Styled.Container ref={innerRef}>
      {!isFetching && ui.modalMonitoring.isShow && (
        <FuelFlex
          defaultProps={{
            alignItems: 'center',
            gap: 'km4',
            justifyContent: 'space-between',
          }}
        >
          <div>
            <FuelTypography
              tag="h4"
              size={description ? 'body-lg' : 'body-sm'}
              weight="bold"
            >
              {title}
            </FuelTypography>
            {description && (
              <FuelTypography
                size="body-md"
                color="neutral-default"
                weight="medium"
              >
                {description}
              </FuelTypography>
            )}
          </div>
          <FuelFlex
            defaultProps={{
              gap: 'km4',
            }}
          >
            {handleActionDispute()}
            {hasConfirmed && (
              <FuelButton
                data-testid="sectionAction-button"
                onClick={action.onClick}
                size="large"
                trailingIcon={action.icon}
              >
                {action.text}
              </FuelButton>
            )}
          </FuelFlex>
        </FuelFlex>
      )}
    </Styled.Container>
  );
}

export default SectionAction;
